export enum TooltipsStatusesEnum {
  todo = 'todo',
  skipped = 'skipped',
  done = 'done',
}
